import React, { useState, useEffect, useContext } from 'react';
import { Button, message, Row, Col, Divider, Spin, Space, Checkbox, List, Typography, Modal, Form, Select, Input, Card, Radio } from 'antd';
import AppContext from "../AppContext";
import { ReloadOutlined, PlusOutlined,MinusCircleOutlined } from "@ant-design/icons";
import { onCreateDepartment, onGetDepartment, onEditDepartment } from '../../Controller/Management/DepartmentManagement';
import T_Error from "../404";
import { getAllUserLists } from '../../Controller/Management/UserProf_Ctrl';
import { fullBrowserVersion } from 'react-device-detect';

const { Option }                    = Select;
const { Meta }                      = Card;
export default function DepartmentManagement(prop){
    //===== VARIABLE ====
    const global                                = useContext(AppContext);
    const [departmentlist, setDepartmentList]   = useState([]);
    const [isMaintenance, setIsMaintenance]     = useState(false);      // Used for maintenance
    const [btndisable, setBtnDisable]           = useState(false);
    const [form]                                = Form.useForm();
    // ===== LIST ======
    const [initLoading, setInitLoading]         = useState(true);
    //======= MODAL ========
    const [isModalVisible, setIsModalVisible]   = useState("");
    const [modalTitle, setModalTitle]           = useState("");
    const [action, setAction]                   = useState("");
    const [FULLuserLists, setFULLUserLists]     = useState([]);
    const formItemLayout = {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
      };
      const formItemLayoutWithOutLabel = {
        wrapperCol: {
          xs: { span: 24, offset: 0 },
          sm: { span: 20, offset: 6 },
        },
      };
    //====== 20211011 WORK FIXED TIME =======
    //const [workFixed, setWorkFixed]             = useState(1);
    // RADIO GROUP OPTIONS
    // const isworkfixedoptions = [{
    //     value   : 1,
    //     name    : "Fixed"
    // },
    // {
    //     value   : 0,
    // }];
    
    async function LoadFullUserListing()
    {
        var result = await getAllUserLists("")

        setFULLUserLists(result.data)

        return(result.data)
        
    }

    //===== USE EFFECT ========
    useEffect(() => {
        onRefresh();
        
    },[]);




    //===== FUNCTION =====
    async function onRefresh(){
        
        var result = await getAllUserLists("")

        setFULLUserLists(result.data)

        let tempuserid = result.data

        onGetDepartment({})
        .then(val => {

          
            let index = 0
            val.data.forEach((item) => {
                if(item.hod)
                {
                    
                  
                    let tempuserid1 = tempuserid.filter(x => x._id == val.data[index].hod)[0].userid
                  
                    val.data[index].hod = tempuserid1
                }
                index++
            })
            setDepartmentList(val.data);
            setInitLoading(false);
            setBtnDisable(false);
            return val;
        })
        .catch(err => {
            message.error(err.msg);
            setIsMaintenance(true);
        });

    }

    
    //20210727 add refresh all windows
    const onReload = () => {
        setBtnDisable(true);
        window.location.reload();
    }

    const onFinish = (data) => {
     
       
        console.log("create data >>>",data)
        
        if(data.hod != undefined || data.hod != "")
        {
            let tempuserid = FULLuserLists.filter(x => x.userid == data.hod)[0]._id

            data.hod = tempuserid
        }
       
        

        switch(action){
            case "create":
                return onCreateDepartment(data)
                .then(result => {
                    onRefresh();
                    setIsModalVisible(false);
                });
            case "edit":
                data.departmentid   = data._id;
                return onEditDepartment(data)
                .then(result => {
                    onRefresh();
                    form.resetFields()
                    setIsModalVisible(false);
                });
                break;
            default:
                message.error("unknown operation, check your interface and try again");
                setIsModalVisible(false);
                return;
        }
    }

    //===== FORM =======
    const onDepartmentProfForm = () => {
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 14 },
            },
        };
        return (
            <Form form={form} onFinish={onFinish} {...formItemLayoutWithOutLabel}>
                {
                    <>
                        {/* ID */}
                        <Form.Item name={"_id"} style={{display: "none"}}></Form.Item>
                        {/* SHIFT NAME  */}
                        <Form.Item name={"name"} label="Name" rules={[{ required: true, message: "Department Name is required" }]}
                            {...formItemLayout}>
                            <Input />
                        </Form.Item>
                        <Form.Item name={"hod"} label="HOD"
                            {...formItemLayout}>
                            <Select placeholder={"HOD"}  showSearch>
                                {
                                    
                                    FULLuserLists.map(function(data){
                                        return (
                                            <Option value={data.userid}>{`${data.userid} (${data.markingcode})`}</Option>
                                        )
                                    })
                                }
                            </Select>
                        </Form.Item>
                 
                        {/* <Form.List
                            name="typelist"
                            >
                                {(fields, { add, remove }, { errors }) => (
                                <>
                                {fields.map((field, index) => (
                                <Form.Item
                                {...(index === 0 ? formItemLayout : formItemLayoutWithOutLabel)}
                                label={index === 0 ? 'Task Type Listing :' : ''}
                                required={false}
                                key={field.key}
                                >
                                    <Form.Item
                                    {...field}
                                    validateTrigger={['onChange', 'onBlur']}
                                    rules={[
                                        {
                                            required: true,
                                            whitespace: true,
                                            message: "Please input Task Type.",
                                        },
                                    ]}
                                    noStyle
                                    >
                                    <Input placeholder="Task Type Name" style={{ width: '60%' }} />
                                    </Form.Item>
                                    {fields.length > 1 ? (
                                    <MinusCircleOutlined style={{color:'red'}}
                                    className="dynamic-delete-button"
                                    onClick={() => remove(field.name)}
                                    />
                                    ) : null}
                                    </Form.Item>
                                    ))}
                                    <Form.Item>
                                        <Button
                                        type="dashed"
                                        onClick={() => add()}
                                        style={{ width: '60%' }}
                                        icon={<PlusOutlined />}
                                        >
                                            Add field
                                        </Button>
                                        <Form.ErrorList errors={errors} />
                                        </Form.Item>
                                        </>
                                        )}
                                        </Form.List>
                                        <Form.Item>

                                        </Form.Item> */}
                                        </> 
                            }
                    </Form>
        )
    }

    //===== LIST =======
    const renderDepartmentItem = (item) => {
       
        return (
            <List.Item
                visible={"false"}
            >
                <Card
                    onClick={() => {
                        form.setFieldsValue(item);
                        showModal('edit');
                    }}
                    hoverable
                    className="list-card-item-BO"
                    style={{
                        minHeight: "100%",
                        borderRadius: "10px",
                        textAlign: "center"
                    }}
                >
                    <Meta
                        title={
                            <font
                                className="gradient-text"
                                style={{
                                    fontSize: '2.50em'

                                }} size="large">
                                {item["name"]}
                            </font>
                        }
                        description={<>
                            <Row justify="center">
                                {/* <Tag color="geekblue">
                                    {data["country"]}
                                </Tag>
                                <Tag color="geekblue">
                                    {data["ip"]}
                                </Tag> */}
                            </Row>
                        </>}
                    />
                </Card>
            </List.Item>
        )
    }

    //====== MODAL ======
    const onDepartmentModal = () => {
        return (
            <Modal
                title           ={modalTitle}
                visible         ={isModalVisible}
                destroyOnClose  ={true}
                style           ={{ maxWidth: "80%" }}
                bodyStyle       ={{ overflow: "auto", maxHeight: "70vh"}}
                onOk            ={handleOk}
                onCancel        ={handleCancel}
                okText          ="Submit"
                >
            {onDepartmentProfForm()}
            </Modal>
        )
    }

    const showModal = (modalAction) => {
        // setModalAction(modalAction);
        switch (modalAction) {
            case "create":
                setAction("create");
                setModalTitle(`New Department`);
                setIsModalVisible(true);
                break;
            case "edit":
                setAction("edit");
                setModalTitle("Edit Department");
                setIsModalVisible(true);
                break;
            default:
                message.error("No Action required");
                break;
        }
    }

    const onDepartmentManagementForm = () => {
        return (
            <>
                <Row justify="start">
                    <Divider>{prop.title ?? "."}</Divider>
                </Row>            
                {/* HEADER */}
                {/* BODY */}
                <Row>
                    <Col span={24}>
                        <div style={{float:"right"}}>
                            <Space size={2}>
                                <Button onClick={() => { showModal("create")}}><PlusOutlined /></Button>
                                <Button onClick={onReload}>{ btndisable ?  <Spin /> : <ReloadOutlined />}</Button>
                            </Space>
                        </div>

                    </Col>
                </Row>
                {/* {onFilterForm()} */}
                <Row gutter={[8,8]}>
                    <Col xs={24}>
                        <List {...listProps}></List>
                    </Col>
                </Row>
            </>   
        )
    }

    const handleOk = () => {
        form.submit();
    }

    const handleCancel = () => {
        form.resetFields()
        setAction("");
        setIsModalVisible(false);
    }

    //====== PROPS ========
    const listProps = {
        loading     : initLoading,
        dataSource  : departmentlist,
        itemLayout  : "horizontal",
        grid        : { gutter: 16, xs: 2, sm: 2, md: 3, lg: 4, xl: 5, xxl: 6 },
        renderItem  : renderDepartmentItem
    }

    return (
        <>
            {(() => {
                if(isMaintenance){
                    return (<T_Error />)
                }
                else{
                    return (
                        <>
                        {onDepartmentManagementForm()}
                        {onDepartmentModal()}
                    </>
                    )
                }
            })()}
        </>
    )
}